<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="item in 2" :key="item">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form v-show="!showSkeleton" ref="form">
      <div v-if="!edicao" class="text-h4 mb-7">
        Cadastro de Centro de Custo
      </div>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :counter="30"
            label="Descrição"
            outlined
            :error-messages="descriptionErrors"
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="form.codigo"
            :error-messages="codigoErrors"
            label="Código"
            outlined
            @input="
              $v.form.codigo.$touch()
              form.codigo = $event.toString().trim()
            "
            @blur="$v.form.codigo.$touch()"
          />
        </v-col>
      </v-row>
      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'

import centroDeCustoStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import CentroDeCustoHttpService from '../_services/CentroDeCustoHttpService'

export default {
  name: 'CadastroCentroDeCusto',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      codigo: '',
    },
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('cadastroCentroDeCustoModulePABXStore', ['getCentroDeCustoSelecionado']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'cadastroCentroDeCustoModulePABXStore', centroDeCustoStore)

    if (this.edicao === 'true') {
      this.form = this.getCentroDeCustoSelecionado
    }

    this.showSkeleton = false
  },

  methods: {
    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      try {
        if (this.edicao === 'true') {
          await CentroDeCustoHttpService.putCentroDeCustos(this.form)
        } else {
          await CentroDeCustoHttpService.postCentroDeCustos(this.form)
        }
        this.$router.push({ name: 'Centrodecustos' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Centrodecustos' })
    },
  },
}
</script>
